import React from 'react';
import { useAppContext } from '@/components/AppContext';
import { useMjolnir } from '@/components/Ajax';

export default function useLoadDeployments() {
	const { app } = useAppContext();

	return useMjolnir(`/api/1/pastease/${app.domain}/${app.organisations.current.org_id}`);
}
